interface LogoXSProps {
  className?: string;
  variant?: 'light' | 'dark';
}

export default function LogoXS({ className = "", variant = 'light' }: LogoXSProps) {
  
  const iconBgFill = variant === 'light' ? 'black' : 'white';
  const starFill = variant === 'light' ? 'white' : 'black';
  
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 6.17969C0 2.76674 2.76674 0 6.17969 0H21.8203C25.2333 0 28 2.76674 28 6.17969V21.8203C28 25.2333 25.2333 28 21.8203 28H6.17969C2.76674 28 0 25.2333 0 21.8203V6.17969Z"
        fill={iconBgFill}
      />
      <path
        d="M13.0052 7.68261C13.3906 6.82244 14.6093 6.82244 14.9948 7.68261L19.7136 18.2129C20.136 19.1555 19.1375 20.1047 18.2203 19.6325L14.4984 17.716C14.1856 17.5549 13.8144 17.5549 13.5016 17.716L9.77964 19.6325C8.86245 20.1047 7.86401 19.1555 8.28644 18.2129L13.0052 7.68261Z"
        fill={starFill}
      />
      <path
        d="M12.6226 7.51044C13.1563 6.31943 14.8437 6.31944 15.3774 7.51044L20.0962 18.0407C20.6811 19.3459 19.2986 20.6602 18.0287 20.0063L14.3067 18.0898C14.1142 17.9907 13.8858 17.9907 13.6933 18.0898L9.97134 20.0063C8.70138 20.6602 7.31894 19.3459 7.90383 18.0407L12.6226 7.51044ZM14.9948 7.68261C14.6093 6.82244 13.3906 6.82244 13.0052 7.68261L8.28644 18.2129L8.27681 18.2349C7.88274 19.1629 8.85412 20.0864 9.75815 19.6433L9.77964 19.6325L13.5016 17.716C13.8144 17.5549 14.1856 17.5549 14.4984 17.716L18.2203 19.6325C19.1304 20.1011 20.1204 19.1703 19.7232 18.2349L19.7136 18.2129L14.9948 7.68261Z"
        fill={starFill}
      />
    </svg>
  );
}
